import { AitRowGroupData } from "aic";
import { hasStylesToRemove } from "editor-v3";
import { STYLES_TO_CLEAN, STYLES_TO_DELETE } from "../../../config";
import { hasStylesInReplacementValues } from "./hasStylesInReplacementValues";
import { hasStylesInRow } from "./hasStylesInRow";

/**
 * Checks if a row group contains any Optional or Notes styles.
 * Checks all rows in the group, as well as any comments and replacements
 * associated with the row group.
 *
 * @template T - Content type for row cells
 * @param rowGroup - The row group to check for styles
 * @returns True if any row, comment, or replacement contains styles to remove, false otherwise
 */
export const hasStylesInRowGroup = <T>(rowGroup: AitRowGroupData<T>): boolean => {
  const hasStylesInRows = rowGroup.rows.some((row) => hasStylesInRow(row));

  const hasStylesInComments = hasStylesToRemove(rowGroup.comments, [
    ...STYLES_TO_CLEAN,
    ...STYLES_TO_DELETE,
  ]);

  const hasStylesInReplacements = (rowGroup.replacements ?? []).some((replacement) =>
    hasStylesInReplacementValues(replacement.newTexts ?? []),
  );

  return hasStylesInRows || hasStylesInComments || hasStylesInReplacements;
};
